<template>
	<div>
		<a-button type="primary" size="small" @click="showBillsDetail">
			{{ $t('billsReceivable.billDetails') }}
		</a-button>
		<a-modal
			:title="$t('billsReceivable.billDetails')"
			:visible="visible_bills_detail"
			@cancel="close"
			width="800"
			keyboard
		>
			<template>
				<div style="textAlign:left;fontSize:16px;fontWeight:bold;">
					<div>
						<span>{{ $t('billsReceivable.customerName') }}：</span>
						<span>{{ billsDetail.customerName }}</span>
					</div>
					<div>
						<span>{{ $t('billsReceivable.billNumber') }}：</span>
						<span>{{ billsDetail.number }}</span>
					</div>
					<div>
						<span>{{ $t('billsReceivable.billDate') }}：</span>
						<span>{{ billsDetail.fromDate }} {{ $t('to') }} {{ billsDetail.toDate }}</span>
					</div>
					<div style="lineHeight:45px;">
						<span>{{ $t('billsReceivable.receivable') }}：</span>
						<span>
							<AmountText :value="billsDetail.receivableAmount" :currency="billsDetail.currency" />
						</span>
					</div>
				</div>
				<div>
					<a-table
						:columns="columns"
						:data-source="tableList"
						:pagination="false"
						bordered
						:rowKey="(record, index) => index"
					>
					<template slot="subTotal" slot-scope="scope, record">
						<div style="text-align: right;">
							<AmountText :value="record.subTotal" :currency="record.currency" />
						</div>
					</template>
					</a-table>
				</div>
			</template>
			<template slot="footer" class="footer">
				<a-button key="back" @click="close">
					{{ $t('close') }}
				</a-button>
			</template>
		</a-modal>
	</div>
</template>

<script>
import { searchReqParam } from "../../../../utils/searchReqParam";
import { queryBillingReportDetail } from "../../../../api/receivable";
import i18n from '@/locales/i18n'
import AmountText from '../../../../components/AmountText.vue'

const columns = [
	{
		title: i18n.t('billsReceivable.boxMakingTime'),
		dataIndex: "planArrivalTime",
		key: "planArrivalTime",
		align: "center",
	},
	{
		title: i18n.t('businessDispatch.billNumber'),
		dataIndex: "blNo",
		key: "blNo",
		align: "center",
	},
	{
		title: i18n.t('businessDispatch.caseNumber'),
		key: "containerNumber",
		dataIndex: "containerNumber",
		align: "center",
	},
	{
		title: i18n.t('businessDispatch.boxType'),
		key: "containerSize",
		dataIndex: "containerSize",
		align: "center",
	},
	{
		title: i18n.t('businessDispatch.businessNumber'),
		dataIndex: "orderNumber",
		key: "orderNumber",
		align: "center",
	},
	{
		title: i18n.t('subtotal'),
		dataIndex: "subTotal",
		key: "subTotal",
		scopedSlots: { customRender: 'subTotal' },
		align: "center",
	},
];

export default {
	name: "bills-detail",
	components:{
		AmountText
	},
	props: {
		selectedRows: {
			type: Array,
			default() {
				return [];
			},
		},
	},
	data() {
		return {
			req: searchReqParam(),
			params: { billingReportId: "" },
			visible_bills_detail: false,
			billsDetail: {},
			tableList: [],
			columns,
		};
	},
	methods: {
		showBillsDetail() {
			if (this.selectedRows.length >= 1) {
				this.req.params.billingReportId = this.selectedRows[0].billingReportId;
				this.billsDetail = this.selectedRows[0];
				console.log(this.req);
				queryBillingReportDetail(this.req).then((res) => {
					let temp = JSON.parse(res.data);
					console.log(temp);
					if (!temp.success || temp.code != 0) {
						this.$message.error(temp.msg);
						return;
					}
					this.tableList = temp.data;
				});
				this.visible_bills_detail = true;
			} else {
				this.$message.error(this.$t('businessDispatch.feedbackTransportNode[0]'));
			}
		},
		close() {
			console.log("close");
			this.tableList = [];
			this.visible_bills_detail = false;
		},
	},
};
</script>

<style lang="less" scoped>
/deep/ .ant-modal {
	width: 800px;
}
</style>
